import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';

import { useStore } from '@nanostores/react';
import { Navigate, useLocation } from 'react-router-dom';

import { WorkspaceSkeleton } from '@/app/layouts';
import { sessionStore } from '@/entities/session';
import { logger } from '@/shared';

import { appendReturnTo } from './returnTo';

interface AuthGateProps {
  children: ReactNode;
}

export function AuthGate({ children }: AuthGateProps) {
  const session = useStore(sessionStore);
  const location = useLocation();
  const prevStatusRef = useRef(session.status);

  useEffect(() => {
    if (prevStatusRef.current === session.status) {
      return;
    }
    prevStatusRef.current = session.status;
    logger.info('auth gate status changed', { status: session.status });
  }, [session.status]);

  switch (session.status) {
    case 'loading':
      return <WorkspaceSkeleton />;
    case 'unauthenticated':
      return <Navigate to={appendReturnTo('/login', location.pathname)} replace />;
    case 'authenticated':
      return children;
    default: {
      const _exhaustive: never = session.status;
      void _exhaustive;
      return <WorkspaceSkeleton />;
    }
  }
}
